/* ESY · Reubicación — comportamiento común (aparición, raíles, chips, parallax) */
(function () {
  if (window.__esyR) { window.__esyR.scan(document); return; }
  var R = (window.__esyR = {});
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* 1 · Aparición al entrar en pantalla (por geometría: el recorte con clip-path engaña al IntersectionObserver) */
  var pend = [], revOn = false, revTick = false;
  function revealRun() {
    if (!pend.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var keep = [];
    for (var i = 0; i < pend.length; i++) {
      var el = pend[i];
      if (!el.isConnected) continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) { keep.push(el); continue; }
      if (r.top < vh * 0.94 && r.bottom > 0) el.classList.add('is-in'); else keep.push(el);
    }
    pend = keep;
  }
  function revealQueue() { if (revTick) return; revTick = true; requestAnimationFrame(function () { revTick = false; revealRun(); }); }
  function reveal(root) {
    root.querySelectorAll('[data-r]:not(.is-in)').forEach(function (el) {
      if (reduce) { el.classList.add('is-in'); return; }
      if (el.__esyrQ) return; el.__esyrQ = 1; pend.push(el);
    });
    if (!revOn) {
      revOn = true;
      window.addEventListener('scroll', revealQueue, { passive: true });
      window.addEventListener('resize', revealQueue, { passive: true });
      window.addEventListener('load', revealQueue);
      document.addEventListener('scroll', revealQueue, { capture: true, passive: true });
      setInterval(function () { if (pend.length) revealRun(); }, 1200);
    }
    revealRun();
    setTimeout(revealRun, 120);
  }

  /* 2 · Raíles horizontales: flechas, barra de progreso, arrastre con ratón y avance automático */
  function initRail(wrap) {
    wrap.setAttribute('data-ready', '1');
    var track = wrap.querySelector('[data-track]');
    if (!track) return;
    var prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]'), bar = wrap.querySelector('[data-bar]');
    function one() { var c = track.children[0]; var g = parseFloat(getComputedStyle(track).columnGap) || 0; return c ? c.getBoundingClientRect().width + g : track.clientWidth; }
    function page() { var w = one(); return Math.max(1, Math.floor((track.clientWidth + 2) / w)) * w; }
    function upd() {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      if (bar) bar.style.setProperty('--p', p.toFixed(3));
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: reduce ? 'auto' : 'smooth' }); });
    var raf = 0;
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; upd(); }); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function (e) {
      if (!down) return; var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (moved) { var w = one(); track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' }); }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    var drift = parseFloat(wrap.getAttribute('data-drift') || '0');
    if (drift > 0 && !reduce && !design) {
      var hold = false, vis = false, t = 0;
      function pause() { hold = true; clearTimeout(t); t = setTimeout(function () { hold = false; }, 6000); }
      ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (ev) { wrap.addEventListener(ev, pause, { passive: true }); });
      wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = true; });
      wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold = false; });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: 0.4 }).observe(wrap);
      setInterval(function () {
        if (hold || !vis || document.hidden) return;
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: one(), behavior: 'smooth' });
      }, drift * 1000);
    }
  }
  function rails(root) { root.querySelectorAll('[data-esyr-rail]:not([data-ready])').forEach(initRail); }

  /* 3 · Chips de colecciones: centrar la activa, saltar dentro de la página y resaltar al hacer scroll */
  function center(a) { var row = a.parentElement; if (!row) return; row.scrollTo({ left: a.offsetLeft - (row.clientWidth - a.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
  function initChips(nav) {
    nav.setAttribute('data-ready', '1');
    var act = nav.querySelector('.is-active'); if (act) { var row = act.parentElement; row.scrollLeft = act.offsetLeft - (row.clientWidth - act.offsetWidth) / 2; }
    if (nav.getAttribute('data-anchor-mode') !== '1') return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-anchor]'));
    var map = [];
    links.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('data-anchor'));
      if (!t) return;
      map.push([t, a]);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var pc = window.matchMedia('(min-width: 750px)').matches;
        var hd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--esy-hd-h')) || parseFloat(nav.getAttribute(pc ? 'data-off-pc' : 'data-off-m')) || 0;
        var off = nav.getBoundingClientRect().height + hd + 6;
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if (!map.length || !('IntersectionObserver' in window)) return;
    var spy = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        map.forEach(function (m) {
          var on = m[0] === e.target; m[1].classList.toggle('is-active', on);
          if (on) center(m[1]);
        });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    map.forEach(function (m) { spy.observe(m[0]); });
  }
  function chips(root) { root.querySelectorAll('[data-esyr-chips]:not([data-ready])').forEach(initChips); }

  /* 4 · Parallax suave de imágenes */
  var px = [], pxOn = false;
  function runPx() {
    var vh = window.innerHeight;
    px = px.filter(function (el) { return el.isConnected; });
    px.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < -100 || box.top > vh + 100) return;
      var k = parseFloat(el.getAttribute('data-parallax')) || 0.12;
      var c = box.top + box.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (-c * k).toFixed(1) + 'px,0) scale(' + (1 + k * 1.6).toFixed(3) + ')';
    });
  }
  function parallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-parallax]:not([data-ready])').forEach(function (el) { el.setAttribute('data-ready', '1'); px.push(el); });
    if (!pxOn && px.length) {
      pxOn = true; var tick = false;
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(function () { tick = false; runPx(); }); } }, { passive: true });
      window.addEventListener('resize', runPx);
    }
    runPx();
  }

  /* 5 · Vídeos: reproducir solo cuando se ven */
  function videos(root) {
    if (!('IntersectionObserver' in window)) return;
    root.querySelectorAll('video[data-esyr-auto]:not([data-ready])').forEach(function (v) {
      v.setAttribute('data-ready', '1'); v.muted = true; v.playsInline = true;
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: 0.2 }).observe(v);
    });
  }

  /* 6 · Inclinación 3D de tarjetas al mover el ratón */
  function tilt(root) {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('.esyr-tilt .esyr-card:not([data-tilt])').forEach(function (card) {
      card.setAttribute('data-tilt', '1');
      var m = card.querySelector('.esyr-card__m'); if (!m) return;
      var k = parseFloat(getComputedStyle(card).getPropertyValue('--r-tilt')) || 7;
      card.addEventListener('pointermove', function (e) {
        var b = m.getBoundingClientRect(); var x = (e.clientX - b.left) / b.width - .5, y = (e.clientY - b.top) / b.height - .5;
        m.classList.add('is-tilting');
        m.style.transform = 'perspective(900px) rotateX(' + (-y * k).toFixed(2) + 'deg) rotateY(' + (x * k).toFixed(2) + 'deg) translateZ(0)';
      });
      card.addEventListener('pointerleave', function () { m.classList.remove('is-tilting'); m.style.transform = ''; });
    });
  }

  /* 7 · Título palabra a palabra */
  function words(root) {
    root.querySelectorAll('.esyr-h.is-words:not([data-split])').forEach(function (h) {
      h.setAttribute('data-split', '1');
      if (!h.hasAttribute('data-r')) h.setAttribute('data-r', '');
      var txt = h.textContent.trim().split(/\s+/); h.textContent = '';
      txt.forEach(function (w, i) { if (i) h.appendChild(document.createTextNode(' ')); var sp = document.createElement('span'); sp.className = 'esyr-w'; sp.style.setProperty('--w', i); sp.textContent = w; h.appendChild(sp); });
    });
  }

  R.scan = function (root) { root = root || document; words(root); reveal(root); rails(root); chips(root); parallax(root); videos(root); tilt(root); };
  document.addEventListener('shopify:section:load', function (e) { R.scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) { var el = e.target; if (el && el.querySelectorAll) { el.classList && el.classList.add('is-in'); el.querySelectorAll('[data-r]').forEach(function (x) { x.classList.add('is-in'); }); } });
  R.scan(document);
})();
